// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__1IL7e","fileBtn":"File_fileBtn__IF2ah","closeBtn":"File_closeBtn__2F_4J","fileSelected":"File_fileSelected__1hUjy","disabled":"File_disabled__21-O9"};